import AppDispatcher from 'AppDispatcher'
import {Actions} from './Constants'

export default {
   create: (nid, key, channel) => {
      AppDispatcher.dispatch({
         actionType: Actions.create,
         nid,
         key,
         channel
      })
   },

   update: (nid, key, channel) => {
      AppDispatcher.dispatch({
         actionType: Actions.update,
         nid,
         key,
         channel
      })
   },

   list: (nid, channels) => {
      AppDispatcher.dispatch({
         actionType: Actions.list,
         nid,
         channels
      })
   },

   change: (nid, key, channel) => {
      AppDispatcher.dispatch({
         actionType: Actions.change,
         nid,
         key,
         channel
      })
   },

   io_recv: (nid, key, data) => {
      AppDispatcher.dispatch({
         actionType: Actions.io_recv,
         nid,
         key,
         data
      })
   },

   io_send: (nid, key, data) => {
      AppDispatcher.dispatch({
         actionType: Actions.io_send,
         nid,
         key,
         data
      })
   },

   token_create: (nid, channel, token) => {
      AppDispatcher.dispatch({
         actionType: Actions.token_create,
         nid,
         channel,
         token
      })
   },

   token_list: (nid, channel, tokens) => {
      AppDispatcher.dispatch({
         actionType: Actions.token_list,
         nid,
         channel,
         tokens
      })
   },

   token_revoke: (nid, channel, token) => {
      AppDispatcher.dispatch({
         actionType: Actions.token_revoke,
         nid,
         channel,
         token
      })
   },

   token_change: (nid, channel, token) => {
      AppDispatcher.dispatch({
         actionType: Actions.token_create,
         nid,
         channel,
         token
      })
   }
}



// WEBPACK FOOTER //
// lib/api/channel/Actions.js